module.exports = __webpack_public_path__ + "img/point.35407761.png";